var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from "react";
import ReactDatepicker, { registerLocale, setDefaultLocale, } from "react-datepicker";
import cx from "classnames";
import { sv } from "date-fns/esm/locale";
import "react-datepicker/dist/react-datepicker.css";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import { InputIcon } from "../input/InputIcon";
import { InputErrorList } from "../input/InputErrorList";
import "../input/Input.scss";
import "./Datepicker.scss";
registerLocale("sv", sv);
setDefaultLocale("sv");
export const Datepicker = (_a) => {
    var { selected, label, placeholder, disabled, readOnly, className, validators = [], forceValidation = false } = _a, props = __rest(_a, ["selected", "label", "placeholder", "disabled", "readOnly", "className", "validators", "forceValidation"]);
    const inputName = useRef("date_" + Math.random().toString(36).substr(2, 9));
    const containerRef = useRef(null);
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(selected || "", validators, forceValidation);
    useForm(inputName.current, validity, selected, resetValidation, containerRef, errorMessages, label);
    const classes = cx("lysa-ui-input", validityClasses, {
        "lysa-ui-input-read-only": readOnly,
    });
    return (React.createElement("div", { ref: containerRef, className: "lysa-ui-input-group" },
        React.createElement("div", { className: "lysa-ui-datepicker" },
            React.createElement("label", { htmlFor: inputName.current }, label),
            React.createElement("div", { className: classes },
                React.createElement(ReactDatepicker, Object.assign({ selected: selected, placeholderText: placeholder, id: inputName.current, name: inputName.current, disabled: disabled, readOnly: readOnly, dateFormat: "yyyy-MM-dd", showYearDropdown: true }, props, { className: classes })),
                React.createElement(InputIcon, null),
                React.createElement(InputErrorList, { errorMessages: errorMessages })))));
};
